import { applyMiddleware, createStore } from 'redux';
import ReduxThunk from 'redux-thunk';
import reducers from '../store/reducers';

const ReduxStore = createStore(reducers, {}, applyMiddleware(ReduxThunk));

export default ReduxStore;
